/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ConfigurationValidationResult,
  ContextTransformationResult,
  GetAllNotificationConfigurationsParams,
  ImportConfigurations200,
  ImportConfigurationsParams,
  NotificationConfigurationDTO,
  NotificationExecutionRequest,
  NotificationResult,
  NotificationTestRequest,
  NotificationTestResult,
  ResolvedRecipients,
  SearchNotificationConfigurationsParams,
  TemplateTestRequest,
  TemplateTestResult,
  TestRecipientResolutionBody
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getNotificationConfigurationById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NotificationConfigurationDTO>(
      {url: `/api/notification-configurations/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetNotificationConfigurationByIdInfiniteQueryKey = (id?: string,) => {
    return [
    'infinite', `/api/notification-configurations/${id}`
    ] as const;
    }

export const getGetNotificationConfigurationByIdQueryKey = (id?: string,) => {
    return [
    `/api/notification-configurations/${id}`
    ] as const;
    }

    
export const getGetNotificationConfigurationByIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getNotificationConfigurationById>>>, TError = unknown>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationConfigurationByIdInfiniteQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationConfigurationById>>> = ({ signal }) => getNotificationConfigurationById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNotificationConfigurationByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationConfigurationById>>>
export type GetNotificationConfigurationByIdInfiniteQueryError = unknown


export function useGetNotificationConfigurationByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNotificationConfigurationById>>>, TError = unknown>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationConfigurationById>>,
          TError,
          Awaited<ReturnType<typeof getNotificationConfigurationById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationConfigurationByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNotificationConfigurationById>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationConfigurationById>>,
          TError,
          Awaited<ReturnType<typeof getNotificationConfigurationById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationConfigurationByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNotificationConfigurationById>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNotificationConfigurationByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNotificationConfigurationById>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNotificationConfigurationByIdInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetNotificationConfigurationByIdQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationConfigurationById>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationConfigurationByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationConfigurationById>>> = ({ signal }) => getNotificationConfigurationById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNotificationConfigurationByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationConfigurationById>>>
export type GetNotificationConfigurationByIdQueryError = unknown


export function useGetNotificationConfigurationById<TData = Awaited<ReturnType<typeof getNotificationConfigurationById>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationConfigurationById>>,
          TError,
          Awaited<ReturnType<typeof getNotificationConfigurationById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationConfigurationById<TData = Awaited<ReturnType<typeof getNotificationConfigurationById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationConfigurationById>>,
          TError,
          Awaited<ReturnType<typeof getNotificationConfigurationById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationConfigurationById<TData = Awaited<ReturnType<typeof getNotificationConfigurationById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNotificationConfigurationById<TData = Awaited<ReturnType<typeof getNotificationConfigurationById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNotificationConfigurationByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const updateNotificationConfiguration = (
    id: string,
    notificationConfigurationDTO: NotificationConfigurationDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<NotificationConfigurationDTO>(
      {url: `/api/notification-configurations/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: notificationConfigurationDTO
    },
      options);
    }
  


export const getUpdateNotificationConfigurationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationConfiguration>>, TError,{id: string;data: NotificationConfigurationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNotificationConfiguration>>, TError,{id: string;data: NotificationConfigurationDTO}, TContext> => {

const mutationKey = ['updateNotificationConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNotificationConfiguration>>, {id: string;data: NotificationConfigurationDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  updateNotificationConfiguration(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateNotificationConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof updateNotificationConfiguration>>>
    export type UpdateNotificationConfigurationMutationBody = NotificationConfigurationDTO
    export type UpdateNotificationConfigurationMutationError = unknown

    export const useUpdateNotificationConfiguration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationConfiguration>>, TError,{id: string;data: NotificationConfigurationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateNotificationConfiguration>>,
        TError,
        {id: string;data: NotificationConfigurationDTO},
        TContext
      > => {

      const mutationOptions = getUpdateNotificationConfigurationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const deleteNotificationConfiguration = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/notification-configurations/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteNotificationConfigurationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNotificationConfiguration>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNotificationConfiguration>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteNotificationConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNotificationConfiguration>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteNotificationConfiguration(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteNotificationConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNotificationConfiguration>>>
    
    export type DeleteNotificationConfigurationMutationError = unknown

    export const useDeleteNotificationConfiguration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNotificationConfiguration>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteNotificationConfiguration>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteNotificationConfigurationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getAllNotificationConfigurations = (
    params?: GetAllNotificationConfigurationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NotificationConfigurationDTO[]>(
      {url: `/api/notification-configurations`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetAllNotificationConfigurationsInfiniteQueryKey = (params?: GetAllNotificationConfigurationsParams,) => {
    return [
    'infinite', `/api/notification-configurations`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetAllNotificationConfigurationsQueryKey = (params?: GetAllNotificationConfigurationsParams,) => {
    return [
    `/api/notification-configurations`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllNotificationConfigurationsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllNotificationConfigurations>>>, TError = unknown>(params?: GetAllNotificationConfigurationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllNotificationConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllNotificationConfigurationsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllNotificationConfigurations>>> = ({ signal }) => getAllNotificationConfigurations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllNotificationConfigurations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllNotificationConfigurationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllNotificationConfigurations>>>
export type GetAllNotificationConfigurationsInfiniteQueryError = unknown


export function useGetAllNotificationConfigurationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllNotificationConfigurations>>>, TError = unknown>(
 params: undefined |  GetAllNotificationConfigurationsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllNotificationConfigurations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllNotificationConfigurations>>,
          TError,
          Awaited<ReturnType<typeof getAllNotificationConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllNotificationConfigurationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllNotificationConfigurations>>>, TError = unknown>(
 params?: GetAllNotificationConfigurationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllNotificationConfigurations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllNotificationConfigurations>>,
          TError,
          Awaited<ReturnType<typeof getAllNotificationConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllNotificationConfigurationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllNotificationConfigurations>>>, TError = unknown>(
 params?: GetAllNotificationConfigurationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllNotificationConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllNotificationConfigurationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllNotificationConfigurations>>>, TError = unknown>(
 params?: GetAllNotificationConfigurationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllNotificationConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllNotificationConfigurationsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllNotificationConfigurationsQueryOptions = <TData = Awaited<ReturnType<typeof getAllNotificationConfigurations>>, TError = unknown>(params?: GetAllNotificationConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllNotificationConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllNotificationConfigurationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllNotificationConfigurations>>> = ({ signal }) => getAllNotificationConfigurations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllNotificationConfigurations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllNotificationConfigurationsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllNotificationConfigurations>>>
export type GetAllNotificationConfigurationsQueryError = unknown


export function useGetAllNotificationConfigurations<TData = Awaited<ReturnType<typeof getAllNotificationConfigurations>>, TError = unknown>(
 params: undefined |  GetAllNotificationConfigurationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllNotificationConfigurations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllNotificationConfigurations>>,
          TError,
          Awaited<ReturnType<typeof getAllNotificationConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllNotificationConfigurations<TData = Awaited<ReturnType<typeof getAllNotificationConfigurations>>, TError = unknown>(
 params?: GetAllNotificationConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllNotificationConfigurations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllNotificationConfigurations>>,
          TError,
          Awaited<ReturnType<typeof getAllNotificationConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllNotificationConfigurations<TData = Awaited<ReturnType<typeof getAllNotificationConfigurations>>, TError = unknown>(
 params?: GetAllNotificationConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllNotificationConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllNotificationConfigurations<TData = Awaited<ReturnType<typeof getAllNotificationConfigurations>>, TError = unknown>(
 params?: GetAllNotificationConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllNotificationConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllNotificationConfigurationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createNotificationConfiguration = (
    notificationConfigurationDTO: NotificationConfigurationDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NotificationConfigurationDTO>(
      {url: `/api/notification-configurations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: notificationConfigurationDTO, signal
    },
      options);
    }
  


export const getCreateNotificationConfigurationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNotificationConfiguration>>, TError,{data: NotificationConfigurationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createNotificationConfiguration>>, TError,{data: NotificationConfigurationDTO}, TContext> => {

const mutationKey = ['createNotificationConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNotificationConfiguration>>, {data: NotificationConfigurationDTO}> = (props) => {
          const {data} = props ?? {};

          return  createNotificationConfiguration(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateNotificationConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof createNotificationConfiguration>>>
    export type CreateNotificationConfigurationMutationBody = NotificationConfigurationDTO
    export type CreateNotificationConfigurationMutationError = unknown

    export const useCreateNotificationConfiguration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNotificationConfiguration>>, TError,{data: NotificationConfigurationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createNotificationConfiguration>>,
        TError,
        {data: NotificationConfigurationDTO},
        TContext
      > => {

      const mutationOptions = getCreateNotificationConfigurationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const validateConfiguration = (
    notificationConfigurationDTO: NotificationConfigurationDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ConfigurationValidationResult>(
      {url: `/api/notification-configurations/validate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: notificationConfigurationDTO, signal
    },
      options);
    }
  


export const getValidateConfigurationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateConfiguration>>, TError,{data: NotificationConfigurationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof validateConfiguration>>, TError,{data: NotificationConfigurationDTO}, TContext> => {

const mutationKey = ['validateConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateConfiguration>>, {data: NotificationConfigurationDTO}> = (props) => {
          const {data} = props ?? {};

          return  validateConfiguration(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ValidateConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof validateConfiguration>>>
    export type ValidateConfigurationMutationBody = NotificationConfigurationDTO
    export type ValidateConfigurationMutationError = unknown

    export const useValidateConfiguration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateConfiguration>>, TError,{data: NotificationConfigurationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof validateConfiguration>>,
        TError,
        {data: NotificationConfigurationDTO},
        TContext
      > => {

      const mutationOptions = getValidateConfigurationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const testContextTransformation = (
    notificationTestRequest: NotificationTestRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ContextTransformationResult>(
      {url: `/api/notification-configurations/test/transformation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: notificationTestRequest, signal
    },
      options);
    }
  


export const getTestContextTransformationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testContextTransformation>>, TError,{data: NotificationTestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof testContextTransformation>>, TError,{data: NotificationTestRequest}, TContext> => {

const mutationKey = ['testContextTransformation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testContextTransformation>>, {data: NotificationTestRequest}> = (props) => {
          const {data} = props ?? {};

          return  testContextTransformation(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TestContextTransformationMutationResult = NonNullable<Awaited<ReturnType<typeof testContextTransformation>>>
    export type TestContextTransformationMutationBody = NotificationTestRequest
    export type TestContextTransformationMutationError = unknown

    export const useTestContextTransformation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testContextTransformation>>, TError,{data: NotificationTestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testContextTransformation>>,
        TError,
        {data: NotificationTestRequest},
        TContext
      > => {

      const mutationOptions = getTestContextTransformationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const testTemplateProcessing = (
    templateTestRequest: TemplateTestRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TemplateTestResult>(
      {url: `/api/notification-configurations/test/template`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: templateTestRequest, signal
    },
      options);
    }
  


export const getTestTemplateProcessingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testTemplateProcessing>>, TError,{data: TemplateTestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof testTemplateProcessing>>, TError,{data: TemplateTestRequest}, TContext> => {

const mutationKey = ['testTemplateProcessing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testTemplateProcessing>>, {data: TemplateTestRequest}> = (props) => {
          const {data} = props ?? {};

          return  testTemplateProcessing(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TestTemplateProcessingMutationResult = NonNullable<Awaited<ReturnType<typeof testTemplateProcessing>>>
    export type TestTemplateProcessingMutationBody = TemplateTestRequest
    export type TestTemplateProcessingMutationError = unknown

    export const useTestTemplateProcessing = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testTemplateProcessing>>, TError,{data: TemplateTestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testTemplateProcessing>>,
        TError,
        {data: TemplateTestRequest},
        TContext
      > => {

      const mutationOptions = getTestTemplateProcessingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const testRecipientResolution = (
    testRecipientResolutionBody: TestRecipientResolutionBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ResolvedRecipients>(
      {url: `/api/notification-configurations/test/recipients`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: testRecipientResolutionBody, signal
    },
      options);
    }
  


export const getTestRecipientResolutionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testRecipientResolution>>, TError,{data: TestRecipientResolutionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof testRecipientResolution>>, TError,{data: TestRecipientResolutionBody}, TContext> => {

const mutationKey = ['testRecipientResolution'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testRecipientResolution>>, {data: TestRecipientResolutionBody}> = (props) => {
          const {data} = props ?? {};

          return  testRecipientResolution(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TestRecipientResolutionMutationResult = NonNullable<Awaited<ReturnType<typeof testRecipientResolution>>>
    export type TestRecipientResolutionMutationBody = TestRecipientResolutionBody
    export type TestRecipientResolutionMutationError = unknown

    export const useTestRecipientResolution = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testRecipientResolution>>, TError,{data: TestRecipientResolutionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testRecipientResolution>>,
        TError,
        {data: TestRecipientResolutionBody},
        TContext
      > => {

      const mutationOptions = getTestRecipientResolutionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const testNotificationConfigurationComplete = (
    notificationTestRequest: NotificationTestRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NotificationTestResult>(
      {url: `/api/notification-configurations/test/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: notificationTestRequest, signal
    },
      options);
    }
  


export const getTestNotificationConfigurationCompleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testNotificationConfigurationComplete>>, TError,{data: NotificationTestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof testNotificationConfigurationComplete>>, TError,{data: NotificationTestRequest}, TContext> => {

const mutationKey = ['testNotificationConfigurationComplete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testNotificationConfigurationComplete>>, {data: NotificationTestRequest}> = (props) => {
          const {data} = props ?? {};

          return  testNotificationConfigurationComplete(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TestNotificationConfigurationCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof testNotificationConfigurationComplete>>>
    export type TestNotificationConfigurationCompleteMutationBody = NotificationTestRequest
    export type TestNotificationConfigurationCompleteMutationError = unknown

    export const useTestNotificationConfigurationComplete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testNotificationConfigurationComplete>>, TError,{data: NotificationTestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testNotificationConfigurationComplete>>,
        TError,
        {data: NotificationTestRequest},
        TContext
      > => {

      const mutationOptions = getTestNotificationConfigurationCompleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const importConfigurations = (
    notificationConfigurationDTO: NotificationConfigurationDTO[],
    params?: ImportConfigurationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ImportConfigurations200>(
      {url: `/api/notification-configurations/import`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: notificationConfigurationDTO,
        params, signal
    },
      options);
    }
  


export const getImportConfigurationsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importConfigurations>>, TError,{data: NotificationConfigurationDTO[];params?: ImportConfigurationsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof importConfigurations>>, TError,{data: NotificationConfigurationDTO[];params?: ImportConfigurationsParams}, TContext> => {

const mutationKey = ['importConfigurations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importConfigurations>>, {data: NotificationConfigurationDTO[];params?: ImportConfigurationsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  importConfigurations(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportConfigurationsMutationResult = NonNullable<Awaited<ReturnType<typeof importConfigurations>>>
    export type ImportConfigurationsMutationBody = NotificationConfigurationDTO[]
    export type ImportConfigurationsMutationError = unknown

    export const useImportConfigurations = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importConfigurations>>, TError,{data: NotificationConfigurationDTO[];params?: ImportConfigurationsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importConfigurations>>,
        TError,
        {data: NotificationConfigurationDTO[];params?: ImportConfigurationsParams},
        TContext
      > => {

      const mutationOptions = getImportConfigurationsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const executeNotificationConfiguration = (
    code: string,
    notificationExecutionRequest: NotificationExecutionRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NotificationResult>(
      {url: `/api/notification-configurations/execute/${code}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: notificationExecutionRequest, signal
    },
      options);
    }
  


export const getExecuteNotificationConfigurationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeNotificationConfiguration>>, TError,{code: string;data: NotificationExecutionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof executeNotificationConfiguration>>, TError,{code: string;data: NotificationExecutionRequest}, TContext> => {

const mutationKey = ['executeNotificationConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof executeNotificationConfiguration>>, {code: string;data: NotificationExecutionRequest}> = (props) => {
          const {code,data} = props ?? {};

          return  executeNotificationConfiguration(code,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExecuteNotificationConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof executeNotificationConfiguration>>>
    export type ExecuteNotificationConfigurationMutationBody = NotificationExecutionRequest
    export type ExecuteNotificationConfigurationMutationError = unknown

    export const useExecuteNotificationConfiguration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeNotificationConfiguration>>, TError,{code: string;data: NotificationExecutionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof executeNotificationConfiguration>>,
        TError,
        {code: string;data: NotificationExecutionRequest},
        TContext
      > => {

      const mutationOptions = getExecuteNotificationConfigurationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const searchNotificationConfigurations = (
    params: SearchNotificationConfigurationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NotificationConfigurationDTO[]>(
      {url: `/api/notification-configurations/search`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getSearchNotificationConfigurationsInfiniteQueryKey = (params?: SearchNotificationConfigurationsParams,) => {
    return [
    'infinite', `/api/notification-configurations/search`, ...(params ? [params]: [])
    ] as const;
    }

export const getSearchNotificationConfigurationsQueryKey = (params?: SearchNotificationConfigurationsParams,) => {
    return [
    `/api/notification-configurations/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchNotificationConfigurationsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof searchNotificationConfigurations>>>, TError = unknown>(params: SearchNotificationConfigurationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchNotificationConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchNotificationConfigurationsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchNotificationConfigurations>>> = ({ signal }) => searchNotificationConfigurations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchNotificationConfigurations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchNotificationConfigurationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof searchNotificationConfigurations>>>
export type SearchNotificationConfigurationsInfiniteQueryError = unknown


export function useSearchNotificationConfigurationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchNotificationConfigurations>>>, TError = unknown>(
 params: SearchNotificationConfigurationsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchNotificationConfigurations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchNotificationConfigurations>>,
          TError,
          Awaited<ReturnType<typeof searchNotificationConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchNotificationConfigurationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchNotificationConfigurations>>>, TError = unknown>(
 params: SearchNotificationConfigurationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchNotificationConfigurations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchNotificationConfigurations>>,
          TError,
          Awaited<ReturnType<typeof searchNotificationConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchNotificationConfigurationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchNotificationConfigurations>>>, TError = unknown>(
 params: SearchNotificationConfigurationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchNotificationConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useSearchNotificationConfigurationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchNotificationConfigurations>>>, TError = unknown>(
 params: SearchNotificationConfigurationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchNotificationConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchNotificationConfigurationsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSearchNotificationConfigurationsQueryOptions = <TData = Awaited<ReturnType<typeof searchNotificationConfigurations>>, TError = unknown>(params: SearchNotificationConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchNotificationConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchNotificationConfigurationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchNotificationConfigurations>>> = ({ signal }) => searchNotificationConfigurations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchNotificationConfigurations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchNotificationConfigurationsQueryResult = NonNullable<Awaited<ReturnType<typeof searchNotificationConfigurations>>>
export type SearchNotificationConfigurationsQueryError = unknown


export function useSearchNotificationConfigurations<TData = Awaited<ReturnType<typeof searchNotificationConfigurations>>, TError = unknown>(
 params: SearchNotificationConfigurationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchNotificationConfigurations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchNotificationConfigurations>>,
          TError,
          Awaited<ReturnType<typeof searchNotificationConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchNotificationConfigurations<TData = Awaited<ReturnType<typeof searchNotificationConfigurations>>, TError = unknown>(
 params: SearchNotificationConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchNotificationConfigurations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchNotificationConfigurations>>,
          TError,
          Awaited<ReturnType<typeof searchNotificationConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchNotificationConfigurations<TData = Awaited<ReturnType<typeof searchNotificationConfigurations>>, TError = unknown>(
 params: SearchNotificationConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchNotificationConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useSearchNotificationConfigurations<TData = Awaited<ReturnType<typeof searchNotificationConfigurations>>, TError = unknown>(
 params: SearchNotificationConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchNotificationConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchNotificationConfigurationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const exportConfigurations = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NotificationConfigurationDTO[]>(
      {url: `/api/notification-configurations/export`, method: 'GET', signal
    },
      options);
    }
  



export const getExportConfigurationsInfiniteQueryKey = () => {
    return [
    'infinite', `/api/notification-configurations/export`
    ] as const;
    }

export const getExportConfigurationsQueryKey = () => {
    return [
    `/api/notification-configurations/export`
    ] as const;
    }

    
export const getExportConfigurationsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof exportConfigurations>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof exportConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportConfigurationsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportConfigurations>>> = ({ signal }) => exportConfigurations(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof exportConfigurations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ExportConfigurationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof exportConfigurations>>>
export type ExportConfigurationsInfiniteQueryError = unknown


export function useExportConfigurationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof exportConfigurations>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof exportConfigurations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportConfigurations>>,
          TError,
          Awaited<ReturnType<typeof exportConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useExportConfigurationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof exportConfigurations>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof exportConfigurations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportConfigurations>>,
          TError,
          Awaited<ReturnType<typeof exportConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useExportConfigurationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof exportConfigurations>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof exportConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useExportConfigurationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof exportConfigurations>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof exportConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getExportConfigurationsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getExportConfigurationsQueryOptions = <TData = Awaited<ReturnType<typeof exportConfigurations>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportConfigurationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportConfigurations>>> = ({ signal }) => exportConfigurations(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportConfigurations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ExportConfigurationsQueryResult = NonNullable<Awaited<ReturnType<typeof exportConfigurations>>>
export type ExportConfigurationsQueryError = unknown


export function useExportConfigurations<TData = Awaited<ReturnType<typeof exportConfigurations>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportConfigurations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportConfigurations>>,
          TError,
          Awaited<ReturnType<typeof exportConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useExportConfigurations<TData = Awaited<ReturnType<typeof exportConfigurations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportConfigurations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportConfigurations>>,
          TError,
          Awaited<ReturnType<typeof exportConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useExportConfigurations<TData = Awaited<ReturnType<typeof exportConfigurations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useExportConfigurations<TData = Awaited<ReturnType<typeof exportConfigurations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getExportConfigurationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getNotificationConfigurationByCode = (
    code: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NotificationConfigurationDTO>(
      {url: `/api/notification-configurations/by-code/${code}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetNotificationConfigurationByCodeInfiniteQueryKey = (code?: string,) => {
    return [
    'infinite', `/api/notification-configurations/by-code/${code}`
    ] as const;
    }

export const getGetNotificationConfigurationByCodeQueryKey = (code?: string,) => {
    return [
    `/api/notification-configurations/by-code/${code}`
    ] as const;
    }

    
export const getGetNotificationConfigurationByCodeInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getNotificationConfigurationByCode>>>, TError = unknown>(code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationConfigurationByCodeInfiniteQueryKey(code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationConfigurationByCode>>> = ({ signal }) => getNotificationConfigurationByCode(code, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(code), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationByCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNotificationConfigurationByCodeInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationConfigurationByCode>>>
export type GetNotificationConfigurationByCodeInfiniteQueryError = unknown


export function useGetNotificationConfigurationByCodeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNotificationConfigurationByCode>>>, TError = unknown>(
 code: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationByCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationConfigurationByCode>>,
          TError,
          Awaited<ReturnType<typeof getNotificationConfigurationByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationConfigurationByCodeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNotificationConfigurationByCode>>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationByCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationConfigurationByCode>>,
          TError,
          Awaited<ReturnType<typeof getNotificationConfigurationByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationConfigurationByCodeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNotificationConfigurationByCode>>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNotificationConfigurationByCodeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNotificationConfigurationByCode>>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNotificationConfigurationByCodeInfiniteQueryOptions(code,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetNotificationConfigurationByCodeQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationConfigurationByCode>>, TError = unknown>(code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationConfigurationByCodeQueryKey(code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationConfigurationByCode>>> = ({ signal }) => getNotificationConfigurationByCode(code, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationByCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNotificationConfigurationByCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationConfigurationByCode>>>
export type GetNotificationConfigurationByCodeQueryError = unknown


export function useGetNotificationConfigurationByCode<TData = Awaited<ReturnType<typeof getNotificationConfigurationByCode>>, TError = unknown>(
 code: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationByCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationConfigurationByCode>>,
          TError,
          Awaited<ReturnType<typeof getNotificationConfigurationByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationConfigurationByCode<TData = Awaited<ReturnType<typeof getNotificationConfigurationByCode>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationByCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationConfigurationByCode>>,
          TError,
          Awaited<ReturnType<typeof getNotificationConfigurationByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotificationConfigurationByCode<TData = Awaited<ReturnType<typeof getNotificationConfigurationByCode>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNotificationConfigurationByCode<TData = Awaited<ReturnType<typeof getNotificationConfigurationByCode>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationConfigurationByCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNotificationConfigurationByCodeQueryOptions(code,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




